module.exports = __webpack_public_path__ + "static/src/content/images/redzel.5a825a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/redzel.png
// module id = WaRn
// module chunks = 0